<div
  class="module-button"
  [ngClass]="{'inactive': !item.hasPermission}"
>

  <div
    class="icon-wrap"
    [ngClass]="{'highlight': item.highlight}"
  >
    <yu-icon [name]="item.icon"></yu-icon>
  </div>

  <div class="button-title">
    {{ item.name }}
  </div>

  @if (icon) {
    <div class="button-icon icon-background" [ngClass]="colorIcon">
      <yu-icon color="light" [name]="icon"></yu-icon>
    </div>
  }

  <ng-content></ng-content>

</div>
